import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useEffect } from "react";
import axiosInstance from "../../axiosConfig/axios";
import Loading from "../../components/loading/loading";

const Downloading = () => {
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);

  const table = searchParams.get("table");
  const restaurant = searchParams.get("restaurant");

  const storedTable = localStorage.getItem("table");
  const storedRestaurant = localStorage.getItem("restaurant");

  if (table && table !== storedTable) {
    localStorage.setItem("table", table);
  }

  if (restaurant && restaurant !== storedRestaurant) {
    localStorage.setItem("restaurant", restaurant);
  }

  const restaurantId = localStorage.getItem("restaurant");
  const tableId = localStorage.getItem("table");

    useEffect(() => {
    localStorage.removeItem("token");
  }, []);


  const fetchTableState = async () => {
    try {
      const res = await axiosInstance.get(
        `/connector/api/users/tables/state?location_id=${restaurantId}&table_id=${tableId}`
      );

      const currentStatus = res?.data?.status;

      if (currentStatus === 0 || currentStatus === 4) {
        navigate("/menu");
      } else if (currentStatus === 2 || currentStatus === 3) {
        const orderId = res.data?.data.orderId;

        if (orderId) {
          localStorage.setItem("order-id", orderId);
        }
        navigate("/order");
      } else {
        console.warn("حالة غير متوقعة");
      }
    } catch (error) {
      console.error("Error fetching table state:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTableState();
  }, [navigate]);

  return (
    <div>
      <div>{isLoading && <Loading />}</div>

      <ToastContainer />
    </div>
  );
};

export default Downloading;
